import DocumentTypesView from "../DocumentTypesView.vue";
import DocumentTypeList   from "../Pages/DocumentTypeList.vue";
import DocumentTypeEditor from "../Pages/DocumentTypeEditor.vue";

const routes = [
  {
    path: "/mantenimiento/tipos-documento",
    component: DocumentTypesView,
    children: [
      {
        path: "",
        name: "document-type-list",
        component: DocumentTypeList,
      },
      {
        path: "crear",
        name: "document-type-create",
        component: DocumentTypeEditor,
      },
      {
        path: ":id/editar",
        name: "document-type-edit",
        component: DocumentTypeEditor,
      },
    ],
  },
];

export default routes;
